import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { Icons } from '../../../shared/helpers/icons';
import { LucideAngularModule } from 'lucide-angular';
import { CommonModule } from '@angular/common';
import { EopAssistantService } from '../../../shared/services/eopAssistant.service';

@Component({
  selector: 'eop-assistant',
  standalone: true,
  imports: [
    LucideAngularModule,
    CommonModule
  ],
  templateUrl: './eop-assistant.component.html',
  styleUrl: './eop-assistant.component.css'
})
export class EopAssistantComponent {
  icons = Icons;
  eopSuggestions: string[] = [];
  suggestion: string = '';

  showChatbox: boolean = false;
  loading: boolean = false;

  @Input() sectionId: number | null = null;
  @Input() subSectionId: number | null = null;

  @Output() close = new EventEmitter<void>();

  constructor(
    private eopAssistantService: EopAssistantService,
    private elementRef: ElementRef
  ) {}

  openChatbox(): void {
    // Toggle the chatbox
    this.showChatbox = !this.showChatbox;
  
    // If just opened, load suggestions
    if (this.showChatbox) {
      this.loading = true;
      this.eopAssistantService.getEopAssistant(this.sectionId, this.subSectionId).subscribe({
        next: (response) => {
          this.loading = false;
          this.eopSuggestions = response.data;
          console.log(response);
          this.getSuggestion();
        },
        error: (error) => {
          this.loading = false;
          console.error('Error getting EOP suggestion: ', error.message);
        }
      });
    }
  }
  

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.onClose(); 
    }
  }

  getSuggestion() {
    if (this.eopSuggestions && this.eopSuggestions.length > 0) {
      const randomIndex = Math.floor(Math.random() * this.eopSuggestions.length);
      this.suggestion = this.eopSuggestions[randomIndex];
    } else {
      this.suggestion = '';
    }
  }
  
  onClose(): void {
    this.showChatbox = false;
  }
};
